import React from "react";
import IconGlyph from "./IconGlyph";

const WelcomeStep = ({ copy, onStart, name }) => (
  <section className="estate-mapping__welcome">
    <div className="estate-mapping__welcome-icon"><IconGlyph name="building" /></div>
    <h1>{copy.welcome.title.replace("%{name}", name || copy.client_name)}</h1>
    <p>{copy.welcome.body}</p>
    <div className="estate-mapping__welcome-list">
      {copy.welcome.steps.map((item, index) => (
        <div key={item}><span>{index + 1}</span>{item}</div>
      ))}
    </div>
    <button className="estate-mapping__button estate-mapping__button--primary" onClick={onStart}>{copy.welcome.start}</button>
    <small>{copy.welcome.pause}</small>
  </section>
);

export default WelcomeStep;
